document.addEventListener('DOMContentLoaded', function () {

  document.body.addEventListener('click', function (e) {
    const swatch = e.target.closest('li[data-swatch-itemt4]');
    if (!swatch) return;

    const ul = swatch.closest('.swatches-select');
    if (!ul) return;

    const form = swatch.closest('form.nt_cart_form');
    if (!form) return;

    // 1. Visual
    ul.querySelectorAll('li').forEach(li => {
      li.classList.remove('is-selected', 'is-selected-nt');
    });
    swatch.classList.add('is-selected');

    // 2. Opciones actuales
    const options = [];
    form.querySelectorAll('.swatches-select').forEach(u => {
      const active = u.querySelector('.is-selected');
      if (active) options[u.dataset.id] = active.dataset.escape;
    });

    // 3. Variantes
    const jsonEl = form.querySelector('[type="application/json"]');
    if (!jsonEl) return;

    const data = JSON.parse(jsonEl.textContent);
    const variants =
      Array.isArray(data) ? data :
      data.variants ||
      (data.product && data.product.variants) ||
      [];

    const match = variants.find(v =>
      v.options && v.options.every((opt, i) => opt === options[i])
    );
    if (!match) return;

    // 4. SINCRONIZAR TODO LO QUE KALLES REVISA
    let idInput = form.querySelector('input[name="id"]');
    if (!idInput) {
      idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      form.appendChild(idInput);
    }
    idInput.value = match.id;

    let variantInput = form.querySelector('input[name="variant_id"]');
    if (!variantInput) {
      variantInput = document.createElement('input');
      variantInput.type = 'hidden';
      variantInput.name = 'variant_id';
      form.appendChild(variantInput);
    }
    variantInput.value = match.id;

    const select = form.querySelector('select[name="id"]');
    if (select) {
      select.value = match.id;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    console.log('✅ VARIANTE TOTALMENTE SINCRONIZADA:', match.id);
  }, true);

});
